import { CSSProperties } from "react"
import { Toaster as Sonner, ToasterProps } from "sonner"

// theme="light": o app e sempre light (tema por conta via tokens); as cores
// reais vem das vars --popover/--border, que seguem o tema. O import antigo de
// next-themes estava morto (provider nunca montado, caia sempre em "system").
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
